import { createContext, useContext, useState, useCallback, useRef } from "react";
import LoaderModal from "../../common/LoaderModal";

const LoaderContext = createContext(null);

export const LoaderProvider = ({ children }) => {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState("Veuillez patienter...");
  const [autoCloseMs, setAutoCloseMs] = useState(null);
  const [indeterminate, setIndeterminate] = useState(false);
  const [progress, setProgressState] = useState(null);
  const [nonBlocking, setNonBlocking] = useState(false); 

  const timerRef = useRef(null);

  const showLoader = useCallback(({ 
    message: msg = "Veuillez patienter...", 
    autoCloseMs: autoMs = null, 
    indeterminate: ind = false,
    nonBlocking: nb = false 
  } = {}) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    setMessage(msg);
    setIndeterminate(Boolean(ind));
    setProgressState(null);
    setAutoCloseMs(autoMs);
    setNonBlocking(nb); 
    setVisible(true);

    if (autoMs && typeof autoMs === "number" && autoMs > 0) {
      timerRef.current = setTimeout(() => {
        setVisible(false);
        timerRef.current = null;
      }, autoMs);
    }
  }, []);

  const hideLoader = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    setVisible(false);
    setAutoCloseMs(null);
    setIndeterminate(false);
    setProgressState(null);
    setNonBlocking(false);
  }, []);

  const setProgress = useCallback((value) => {
    const v = Math.max(0, Math.min(100, Number(value) || 0));
    setProgressState(v);
    if (v >= 100) {
      setTimeout(() => hideLoader(), 400);
    }
  }, [hideLoader]);

  return (
    <LoaderContext.Provider value={{ showLoader, hideLoader, setProgress }}>
      {children}
      <LoaderModal 
        visible={visible} 
        message={message} 
        autoCloseMs={autoCloseMs} 
        progress={progress} 
        indeterminate={indeterminate}
        nonBlocking={nonBlocking} 
      />
    </LoaderContext.Provider>
  );
};

export const useLoader = () => {
  const ctx = useContext(LoaderContext);
  if (!ctx) throw new Error("useLoader must be used within LoaderProvider");
  return ctx;
};